import getValueFromQueryParams from "../utils/parse-query-params";
import fetchShowroomApi from "../utils/fetch-showroom-api";

customElements.component = 'showroom-bridal-persons';

if (!customElements.get(customElements.component)) {
  const selectors = {
    html: "html",
    loader: ".js-loader",
    row: ".js-row",
    card: ".js-card",
    cardName: ".js-card-name",
    cardEmail: ".js-card-email",
    modal: ".js-modal",
    modalInner: ".js-modal-inner",
    modalAdd: ".js-add-modal",
    modalEdit: ".js-edit-modal",
    modalDelete: ".js-delete-modal",
    modalClose: ".js-close-modal",
    personAdd: ".js-add",
    addForm: ".js-add-form",
    editForm: ".js-edit-form",
    deleteForm: ".js-delete-form",
    editButton: ".js-edit-button",
    deleteButton: ".js-delete-button",
    sendEmailButton: ".js-send-email-button",
    tooltip: ".js-email-tooltip",
    modalHow: ".js-modal-how",
    modalHowTrigger: ".js-modal-trigger",
    visible: "visible"
  }

  class ShowroomBridalPersons extends HTMLElement {
    constructor() {
      super();

      this.translations = window.showroom_bridal_persons_t;
      this.icons = window.showroom_bridal_persons_icons;
      this.html = document.querySelector(selectors.html);
      this.loader = this.querySelector(selectors.loader);
      this.row = this.querySelector(selectors.row);
      this.modals = this.querySelectorAll(selectors.modal);
      this.modalAdd = this.querySelector(selectors.modalAdd);
      this.modalEdit = this.querySelector(selectors.modalEdit);
      this.modalDelete = this.querySelector(selectors.modalDelete);
      this.modalClose = this.querySelectorAll(selectors.modalClose);
      this.personAdd = this.querySelector(selectors.personAdd);
      this.addForm = this.querySelector(selectors.addForm);
      this.editForm = this.querySelector(selectors.editForm);
      this.deleteForm = this.querySelector(selectors.deleteForm);
      this.tooltip = this.querySelector(selectors.tooltip);
      this.modalHow = this.querySelector(selectors.modalHow);
      this.modalHowTrigger = document.querySelector(selectors.modalHowTrigger);

      this.data = {}

      this.init();
    }

    async getData() {
      const showroomId = getValueFromQueryParams("id") || window.localStorage.getItem("last_viewed_showroom");

      if (showroomId) {
        this.data = await fetchShowroomApi(`/showrooms/${showroomId}`);

        if (!this.data.currentCustomerIsOwner) {
          this.personAdd.classList.add("hidden");
        } else {
          this.personAdd.classList.remove("hidden");
        }

        const url = new URL(window.location);

        url.searchParams.set("id", this.data.id);
        window.history.pushState({}, '', url);

        window.localStorage.setItem("last_viewed_showroom", showroomId);

        if (!this.data.currentCustomerIsOwner) {
          this.modalHowTrigger.classList.add("hidden");
        }
      } else {
        if (!window.is_customize) {
          window.location.pathname = "/pages/showroom"
        }
      }
    }

    renderLayout() {
      this.data.bridesmaids.forEach(obj => {
        let status = "";

        if (obj.isInvited) status = this.translations.invited;
        if (obj.isJoined) status = this.translations.joined;
        if (obj.isPurchased) status = this.translations.purchased;

        this.row.innerHTML += `
        <div class="showroom-bridal-persons__card js-card ${obj.name ? 'order-1' : ''}" data-id="${obj.id}">
          <div class="showroom-bridal-persons__status ${status.toLowerCase()}">
            ${status && this.icons[status.toLowerCase()]}
            ${status}
          </div>
          <h3 class="showroom-bridal-persons__name js-card-name">${obj.name || "Name"}</h3>
          <div class="showroom-bridal-persons__email js-card-email">${obj.email || "example@mail.com"}</div>
          <div class="showroom-bridal-persons__text">${obj.isInvited ? this.translations.textInvited : this.translations.text}</div>
          ${this.data.currentCustomerIsOwner ? `<div class="btn js-send-email-button${!obj.email || obj.isJoined ? ' hidden' : ''}">${obj.isInvited ? this.translations.resendEmail : this.translations.sendEmail}</div>` : ""}
          ${this.data.currentCustomerIsOwner ? `<div class="showroom-bridal-persons__buttons">
            <div class="showroom-bridal-persons__button js-edit-button">
              ${this.icons.edit}
              ${this.translations.edit}
            </div>
            <div class="showroom-bridal-persons__button js-delete-button">
              ${this.icons.delete}
              ${this.translations.delete}
            </div>
          </div>` : ""}
        </div>
      `;
      })
    }

    initEvents() {
      this.editForm && this.editForm.addEventListener("submit", e => this.editPerson(e))
      this.addForm && this.addForm.addEventListener("submit", e => this.addPerson(e))
      this.deleteForm && this.deleteForm.addEventListener("submit", e => this.deletePerson(e))

      this.modals && this.modals.forEach(modal => {
        modal.addEventListener("click", e => this.handleModalCloseOutside(e, modal))
      })

      this.modalClose && this.modalClose.forEach(el => {
        el.addEventListener("click", () => this.closeModal(el.closest(selectors.modal)))
      })

      this.editButtons = this.querySelectorAll(selectors.editButton);

      this.editButtons && this.editButtons.forEach(button => {
        button.addEventListener("click", () => this.handleEditButton(button))
      })

      this.deleteButtons = this.querySelectorAll(selectors.deleteButton);

      this.deleteButtons && this.deleteButtons.forEach(button => {
        button.addEventListener("click", () => this.handleDeleteButton(button))
      })

      this.sendEmailButtons = this.querySelectorAll(selectors.sendEmailButton);

      this.sendEmailButtons && this.sendEmailButtons.forEach(button => {
        button.addEventListener("click", () => this.handleSendEmailButton(button))
      })

      this.personAdd = this.querySelector(selectors.personAdd);

      this.personAdd && this.personAdd.addEventListener("click", () => this.openModal(this.modalAdd));

      this.modalHowTrigger && this.modalHowTrigger.addEventListener("click", () => this.openModal(this.modalHow))
    }

    handleModalCloseOutside(e, modal) {
      const modalInner = modal.querySelector(selectors.modalInner);

      if (!modalInner.contains(e.target)) {
        this.closeModal(modal);
      }
    }

    handleEditButton(button) {
      const id = button.closest(selectors.card).getAttribute("data-id");
      const name = button.closest(selectors.card).querySelector(selectors.cardName).textContent;
      const email = button.closest(selectors.card).querySelector(selectors.cardEmail).textContent;

      if (name !== "Name" && email !== "example@mail.com") {
        this.modalEdit.querySelector('input[name="First Name"]').value = name;
        this.modalEdit.querySelector('input[name="Email"]').value = email;
      }

      this.modalEdit.querySelector('input[name="id"]').value = id;
      this.openModal(this.modalEdit);
    }

    handleDeleteButton(button) {
      const id = button.closest(selectors.card).getAttribute("data-id");

      this.modalDelete.querySelector('input[name="id"]').value = id;
      this.openModal(this.modalDelete);
    }

    handleSendEmailButton(button) {
      const id = button.closest(selectors.card).getAttribute("data-id");

      button.textContent = this.translations.resendEmail;

      this.sendEmail(id);
    }

    openModal(el) {
      this.html.classList.add("overflow-hidden");
      el.classList.add("opened");
    }

    closeModal(el) {
      this.html.classList.remove("overflow-hidden");
      el.classList.remove("opened");
    }

    async addPerson(e) {
      e.preventDefault();

      const formData = new FormData(this.addForm);
      const showroomId = this.data.id;
      const body = {
        name: formData.get("First Name"),
        email: formData.get("Email")
      }

      await fetchShowroomApi(`/showrooms/${showroomId}/bridesmaids`, "POST", JSON.stringify(body))

      window.location.reload();
    }

    async editPerson(e) {
      e.preventDefault();

      const formData = new FormData(this.editForm);
      const showroomId = this.data.id;
      const bridesmaidId = formData.get("id");
      const body = {
        name: formData.get("First Name"),
        email: formData.get("Email")
      }

      await fetchShowroomApi(`/showrooms/${showroomId}/bridesmaids/${bridesmaidId}`, "PUT", JSON.stringify(body))

      window.location.reload();
    }

    async deletePerson(e) {
      e.preventDefault();

      const formData = new FormData(this.deleteForm);
      const showroomId = this.data.id;
      const bridesmaidId = formData.get("id");

      await fetchShowroomApi(`/showrooms/${showroomId}/bridesmaids/${bridesmaidId}`, "DELETE");

      window.location.reload();
    }

    async sendEmail(id) {
      this.tooltip.classList.add("visible");

      setTimeout(() => {
        this.tooltip.classList.remove("visible");
      }, 3000);

      await fetchShowroomApi(`/showrooms/${this.data.id}/bridesmaids/${id}/invite`, "POST");
    }

    async init() {
      await this.getData();
      this.renderLayout();
      this.initEvents();

      this.loader.classList.remove(selectors.visible);
    }
  }

  customElements.define(customElements.component, ShowroomBridalPersons);
}
